import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appAlphanumericOnly]',
  standalone: false,
})
export class AlphanumericOnlyDirective {
  @Input() maxLength: number = 20;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;
    const sanitizedValue = this.sanitizeInput(initialValue);

    if (initialValue !== sanitizedValue) {
      this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedValue);
      const evt = document.createEvent('Event');
      evt.initEvent('input', false, false);
      this.el.nativeElement.dispatchEvent(evt);
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const char = String.fromCharCode(event.which);

    // Allow backspace, delete, tab, escape, enter
    if (
      [8, 9, 27, 13, 46].indexOf(event.keyCode) !== -1 ||
      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      (event.keyCode === 88 && event.ctrlKey === true) ||
      (event.keyCode === 90 && event.ctrlKey === true)
    ) {
      return;
    }

    // Only allow alphanumeric characters
    if (!/^[a-zA-Z0-9]$/.test(char)) {
      event.preventDefault();
    }

    // Check length limit
    const currentLength = this.el.nativeElement.value.length;
    if (currentLength >= this.maxLength) {
      event.preventDefault();
    }
  }

  sanitizeInput(value: string): string {
    let sanitizedValue = '';
    for (const char of value) {
      if (/^[a-zA-Z0-9]$/.test(char)) {
        sanitizedValue += char;
      }
    }

    if (sanitizedValue.length > this.maxLength) {
      sanitizedValue = sanitizedValue.substring(0, this.maxLength);
    }

    return sanitizedValue;
  }
}
